import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getAuditPageCount } from "../auditLogPage.helpers";

interface AuditLogPaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number | ((page: number) => number)) => void;
}

export function AuditLogPagination({
  page,
  pageSize,
  total,
  onPageChange,
}: AuditLogPaginationProps) {
  return (
    <div className="mt-3 flex items-center justify-between">
      <p className="text-[11px] text-muted-foreground">
        {total} entrée{total !== 1 ? "s" : ""}
      </p>
      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange((currentPage) => Math.max(1, currentPage - 1))}
        >
          <ChevronLeft size={13} />
        </Button>
        <span className="text-[11px] text-muted-foreground">
          Page {page} / {getAuditPageCount(total, pageSize)}
        </span>
        <Button
          variant="secondary"
          size="sm"
          disabled={page * pageSize >= total}
          onClick={() => onPageChange((currentPage) => currentPage + 1)}
        >
          <ChevronRight size={13} />
        </Button>
      </div>
    </div>
  );
}
